import { Ethnicities } from "@/Common/Models/Individuals/Enums/Ethnicity";
import { EthnicityDropdownItem } from "@/Common/Models/UI/Inputs/EthnicityDropdownItem";

class Ethnicity {
    constructor(public key: string, public value: Ethnicities) { }

    public get localKey(): string {
        return cacheStore.GetString(`EthnicityLabel_${this.key}`);
    }

    public toDropdownItem(active: boolean = false): EthnicityDropdownItem {
        return new EthnicityDropdownItem({ Item: this, Active: active });
    }

    public static List(): Ethnicity[] {
        return Object.entries(Ethnicities)
            .filter(keyValue => !isNaN(Number(keyValue[1])))
            .map(([key, value]: [string, Ethnicities]) => new Ethnicity(key, value));
    }

    public static DropdownList(): EthnicityDropdownItem[] {
        return Ethnicity
            .List().map(ethnicity => ethnicity.toDropdownItem());
    }

    public static selectedLabelsOf(keys: Immutable.List<Ethnicities>): string {
        return Ethnicity.List().filter(({ value }) => keys.includes(value)).map(ethnicity => ethnicity.localKey).join(", ");
    }

    public static selectedValuesOf(values: Immutable.List<Ethnicities>): Immutable.List<Ethnicity> {
        return Immutable.List(Ethnicity.List().filter(({ value }) => values.includes(value)));
    }
}

export { Ethnicity };
